/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Range_NmInputs */

const en_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Range (nm)`)
};

const es_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomía máxima (nm)`)
};

const fr_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomie max (nm)`)
};

const de_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. Reichweite (nm)`)
};

const ja_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大航続距離 (海里)`)
};

const zh_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大航程 (海里)`)
};

const ar_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدى الأقصى (ميل بحري)`)
};

const id_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangkauan Maks (nm)`)
};

const it_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomia Max (nm)`)
};

const ru_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макс. дальность (морские мили)`)
};

const pt_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance Máximo (nm)`)
};

const ko_field_range_nm = /** @type {(inputs: Field_Range_NmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 항속 거리 (nm)`)
};

/**
* | output |
* | --- |
* | "Max Range (nm)" |
*
* @param {Field_Range_NmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_range_nm = /** @type {((inputs?: Field_Range_NmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Range_NmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_range_nm(inputs)
	if (locale === "es") return es_field_range_nm(inputs)
	if (locale === "fr") return fr_field_range_nm(inputs)
	if (locale === "de") return de_field_range_nm(inputs)
	if (locale === "ja") return ja_field_range_nm(inputs)
	if (locale === "zh") return zh_field_range_nm(inputs)
	if (locale === "ar") return ar_field_range_nm(inputs)
	if (locale === "id") return id_field_range_nm(inputs)
	if (locale === "it") return it_field_range_nm(inputs)
	if (locale === "ru") return ru_field_range_nm(inputs)
	if (locale === "pt") return pt_field_range_nm(inputs)
	return ko_field_range_nm(inputs)
});